export default "__VITE_ASSET__ed937825__"